import { Rectangle } from '@/modules/Editor/rectangle'

import { drawDashedBox } from './graphicsV2/drawDashedBox'
import type { View } from './views/view'
import { isDefaultMeasureRegion } from '@/modules/Editor/utils/isDefaultMeasureRegion'
import { isDicomView } from '@/modules/Editor/utils/radiology/isDicomView'

export const renderMeasureRegion = (view: View): void => {
  const ctx = view.mainLayer.context
  if (!ctx) {
    return
  }

  // Do not render the measure border on DICOM views
  // (the radiology workflow provides its own overlays; this dashed border is confusing)
  if (isDicomView(view)) {
    return
  }

  const { measureRegion } = view.measureManager
  if (!measureRegion) {
    return
  }

  // Skip drawing the default full-image region to avoid a persistent border
  if (isDefaultMeasureRegion(measureRegion)) {
    return
  }

  const { x, y, w, h } = measureRegion
  const topLeft = view.camera.imageViewToCanvasView({ x, y })
  const bottomRight = view.camera.imageViewToCanvasView({ x: x + w, y: y + h })
  const measureRect = new Rectangle(topLeft, bottomRight)
  drawDashedBox(ctx, measureRect)
}
